import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20pattern%20background%20with%20amber%20and%20cream%20tones%2C%20smooth%20gradient%2C%20minimal%20modern%20design%2C%20soft%20texture%2C%20elegant%20subtle%20overlay%2C%20professional%20corporate%20style%2C%20no%20text&width=1600&height=600&seq=cta-bg-17c&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-900/80 to-background-900/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备好开始使用 17c 了吗？
        </h2>
        <p className="text-background-300 text-sm md:text-base mb-8 max-w-xl mx-auto">
          加入数百万用户的行列，体验 17c 为您带来的效率提升和全新工作方式
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category"
            className="inline-flex items-center px-8 py-3 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            免费开始使用
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center px-8 py-3 text-sm font-semibold rounded-md bg-background-50/10 text-background-50 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}